import { BasketballPlayer } from '@hefe/models';
import {
  BasketballPlayerEditRequest,
  BasketballTeamsSlice,
  ModalsSlice,
  currentUserSelector,
} from '@hefe/store';
import { t } from '@hefe/i18n';
import React, { useState } from 'react';
import { useAppDispatch } from '../../../../store/store';
import CustomForm, {
  FormField,
} from '../../../core/components/form/custom-form';
import { useSelector } from 'react-redux';
import { clubHasSubscription } from '@hefe/utils';
import { AuthSubscriptions } from '@hefe/auth';

interface EditPlayerFormProps {
  player: BasketballPlayer;
}

export default function EditPlayerForm(props: EditPlayerFormProps) {
  const { player } = props;
  const dispatch = useAppDispatch();

  const user = useSelector(currentUserSelector);

  const [hasSpecificTAN, setHasSpecificTAN] = useState(player.team_tan);

  const onSubmit = (values: any, resetForm: any) => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;
    const closeModal = ModalsSlice.modalsActions.closeModal;
    const submitValues: BasketballPlayerEditRequest = {
      user_id: player.id,
      team_id: player.team_id,
      captain: values.captain,
      jersey: values.jersey,
      team_tan: values.tan,
    };

    dispatch(setLoading(true));
    dispatch(BasketballTeamsSlice.updateBasketballPlayer(submitValues))
      .unwrap()
      .then(() => dispatch(closeModal()))
      .catch(() => null)
      .finally(() => dispatch(setLoading(false)));
  };

  const tanField: FormField = {
    name: 'tan',
    label: t('tan'),
    extraLabel: t('information_texts.input_tan'),
    type: 'number',
    initalValue: player.team_tan,
    hidden: !clubHasSubscription(AuthSubscriptions.second, user),
    rules: [
      {
        required: true,
        message: t('form_erros.number'),
      },
      {
        type: 'number',
        min: 1,
        message: t('form_errors.number_min', { min: 1 }),
      },
      {
        type: 'number',
        max: 999,
        message: t('form_errors.number_max', { max: 999 }),
      },
    ],
  };

  const formFields: FormField[] = [
    {
      name: 'captain',
      label: t('captain'),
      type: 'checkbox',
      initalValue: player.captain,
      rules: [],
    },
    {
      name: 'jersey',
      label: t('jersey_number'),
      type: 'text',
      initalValue: player.jersey,
      hidden: !clubHasSubscription(AuthSubscriptions.first, user),
      subscription: AuthSubscriptions.first,
      rules: [
        {
          max: 3,
          message: t('form_errors.max_chars', { max: 3 }),
        },
      ],
    },
    {
      name: 'team_tan',
      label: '',
      type: 'checkbox',
      checkboxText: `${t('team_tan')}?`,
      initalValue: hasSpecificTAN,
      value: hasSpecificTAN,
      onChange: (value) => setHasSpecificTAN(value),
      rules: [],
      hidden: !clubHasSubscription(AuthSubscriptions.second, user),
      subscription: AuthSubscriptions.second,
    },
  ];

  if (hasSpecificTAN) {
    formFields.push(tanField);
  }

  return (
    <CustomForm
      key={`edit-player-form-${player.id}`}
      formId={`edit-player-form-${player.id}`}
      fields={formFields}
      onSubmit={onSubmit}
    />
  );
}
